'use client';

import { useAuth } from '../../contexts/AuthContext';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { DashboardProvider } from '@/components/dashboard/DashboardContext';
import DashboardLayout from '../../components/dashboard/layout/DashboardLayout';
import { Loader2 } from 'lucide-react';


export const defaultLoadingBox =
  <div className="flex flex-col items-center justify-center h-screen">
    <Loader2 className="h-12 w-12 animate-spin text-primary" />
    <p className="text-muted-foreground mt-4">로딩 중...</p>
  </div>

export default function Layout({
  children,
}: {
  children: React.ReactNode
}) {
  const { user, isLoading } = useAuth();
  const router = useRouter();

  // 로그인 상태 확인
  useEffect(() => {
    if (!isLoading && !user) {
      router.push('/');
    }
  }, [isLoading, user, router]);


  if (isLoading) {
    return defaultLoadingBox;
  }

  if (!user) {
    return null; // 사용자가 없으면 렌더링하지 않음 (useEffect에서 리다이렉트 처리)
  }

  return (
    <DashboardProvider>
      <DashboardLayout>
        {children}
      </DashboardLayout>
    </DashboardProvider>
  );
}
